import { useAtomValue } from 'jotai';

import type { OrdersTableRow,PaginatedResponse } from '@ekhodealer/ekho-common';

import { useSearchOrders } from '../api/useSearchOrders';
import { ordersParamsAtom } from '../atoms/ordersAtoms';

/**
 * Hook to calculate the count of orders that require action
 * (orders with pending services provider tasks)
 * Uses the same query params as the table (search, stage filter), but always
 * queries with actionRequired filter enabled to get the count
 */
export function useActionRequiredCount(): number {
	// Get params from atom (includes search, stage filter, and facets)
	const tableParams = useAtomValue(ordersParamsAtom);

	// Override params to always include actionRequired filter
	// This ensures we get the count regardless of whether user has toggled the filter
	const paramsWithActionRequired = {
		...tableParams,
		filters: {
			...tableParams.filters,
			actionRequired: true,
		},
	};

	// Use the modified query to get action required count from response
	const { data: tableData } = useSearchOrders(paramsWithActionRequired);

	const response = tableData as PaginatedResponse<OrdersTableRow> | undefined;
	return response?.count ?? 0;
}
